/**
 * Taking a report away as a spreadsheet or a document.
 *
 * WHY BOTH, RATHER THAN ONE
 * -------------------------
 * They are used for different things. A spreadsheet is opened to be worked
 * on — sorted, filtered, added to a return. A PDF is what gets filed, emailed
 * or handed to an accountant, and it is the one that has to look the same in
 * six months as it does today.
 *
 * WHY A FAILED DOWNLOAD HAS TO SAY SO
 * -----------------------------------
 * A download that fails silently is the worst outcome here: the user pressed
 * the button, nothing appeared, and the natural assumption is that the report
 * is empty rather than that the request was refused. So the error is shown,
 * in the words the server used.
 */
import { useState } from 'react';

import { downloadFile } from '../../lib/download.js';
import { Button } from '../../components/ui/Button.jsx';

export function ReportExport({ path, name }) {
  const [busy, setBusy] = useState(null);
  const [problem, setProblem] = useState(null);

  async function take(format) {
    setBusy(format);
    setProblem(null);
    try {
      const joiner = path.includes('?') ? '&' : '?';
      await downloadFile(`${path}${joiner}format=${format}`, `${name}.${format}`);
    } catch (error) {
      setProblem(error?.message ?? 'That report could not be produced.');
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="secondary" onClick={() => take('csv')} disabled={Boolean(busy)}>
        {busy === 'csv' ? 'Preparing…' : 'Spreadsheet'}
      </Button>
      <Button variant="secondary" onClick={() => take('pdf')} disabled={Boolean(busy)}>
        {busy === 'pdf' ? 'Preparing…' : 'PDF'}
      </Button>

      {problem && (
        <p role="alert" className="text-sm text-bad">
          {problem}
        </p>
      )}
    </div>
  );
}
